module.exports = __webpack_public_path__ + "static/media/profile-dark.fc01c09b.svg";